export function errorsFromResponse(json) {
  let error = ''

  Object.values(json).forEach(arr => {
    error += arr.join(', ')
  })

  return error
}